// (2026-10) En Langiani el CRM clasifica prospectos y oportunidades con las
// Líneas de los artículos (SubDepartamentos) en lugar de las categorías de
// EnvasesBH. Sólo se ofrecen las activas, en orden alfabético; las líneas no
// traen color, así que todas se pintan con el azul de Langiani.
export const COLOR_LINEA = "#003A5C";

export const lineasActivas = (lista) =>
  (lista || [])
    .filter((l) => l.is_active !== "No")
    .sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "es"));
